import { action, makeObservable, observable, runInAction, toJS } from "mobx";
import axios from "axios";

export class StoreAnalytics {
  count = 2;
  defectsByGridTypes = [];
  list = [];
  orgs = [];
  tableModeEventOrg = false;
  tableModeEvetnStatus = false;
  tableModeAnalyz = false;
  summaryData = null;
  DateFrom = new Date();
  DateTo = new Date();
  gridTypeIds = [];
  Eliminated = null;
  organizationIds = [];
  OverBuildingsFrom = null;
  OverBuildingsTo = null;
  LivingBuildingsFrom = null;
  LivingBuildingsTo = null;
  HospitalBuildingsFrom = null;
  HospitalBuildingsTo = null;
  ChildrenBuildingsFrom = null;
  ChildrenBuildingsTo = null;
  DisconnectedFrom = null;
  DisconnectedTo = null;
  dataF = [];

  constructor() {
    makeObservable(
      this,
      {
        tableModeEventOrg: observable,
        tableModeEvetnStatus: observable,
        tableModeAnalyz: observable,
        count: observable,
        list: observable,
        orgs: observable,
        inc: action.bound,
        summaryData: observable.deep,
        defectsByGridTypes: observable.deep,
        getDefectsByGridTypes: action.bound,
        getEventsByOrganization: action.bound,
        getEventsByStatus: action.bound,
        setDate: action.bound,
        setOrgs: action.bound,
        setOverBuildFrom: action.bound,
        setOverBuildTo: action.bound,
        setGridType: action.bound,
        DateFrom: observable,
        DateTo: observable,
        gridTypeIds: observable.deep,
        Eliminated: observable,
        organizationIds: observable.deep,
        OverBuildingsFrom: observable,
        OverBuildingsTo: observable,
        LivingBuildingsFrom: observable,
        LivingBuildingsTo: observable,
        HospitalBuildingsFrom: observable,
        HospitalBuildingsTo: observable,
        ChildrenBuildingsFrom: observable,
        ChildrenBuildingsTo: observable,
        DisconnectedFrom: observable,
        DisconnectedTo: observable,
        getSummary: action.bound,
        setLivingBuildFrom: action.bound,
        setLivingBuildTo: action.bound,
        setHospitalFrom: action.bound,
        setHospitalTo: action.bound,
        setChildrenBuildFrom: action.bound,
        setChildrenBuildTo: action.bound,
        setDisconnectFrom: action.bound,
        setDisconnectTo: action.bound,
        closeTag: action.bound,
        clearFilter: action.bound,
        dataF: observable.deep,
      },
      { deep: true },
    );
  }

  setElim(e) {
    this.Eliminated = e;
    this.getSummary();
  }

  setOrgs(id) {
    if (!this.organizationIds.includes(id)) {
      this.organizationIds.push(id);
    }
    this.getSummary();
    console.log(toJS(this.organizationIds), "orgIds");
  }

  setGridType(id) {
    if (!this.gridTypeIds.includes(id)) {
      this.gridTypeIds.push(id);
    }
    console.log(toJS(this.gridTypeIds), "gridType");
    this.getSummary();
  }

  setOverBuildFrom(e) {
    this.OverBuildingsFrom = e;
  }

  setOverBuildTo(e) {
    this.OverBuildingsTo = e;
  }

  setLivingBuildFrom(e) {
    this.LivingBuildingsFrom = e;
  }

  setLivingBuildTo(e) {
    this.LivingBuildingsTo = e;
  }

  setHospitalFrom(e) {
    this.HospitalBuildingsFrom = e;
  }

  setHospitalTo(e) {
    this.HospitalBuildingsTo = e;
  }

  setChildrenBuildFrom(e) {
    this.ChildrenBuildingsFrom = e;
  }

  setChildrenBuildTo(e) {
    this.ChildrenBuildingsTo = e;
  }

  setDisconnectFrom(e) {
    this.DisconnectedFrom = e;
  }

  setDisconnectTo(e) {
    this.DisconnectedTo = e;
  }

  setDate(from, to) {
    this.DateFrom = from && from[0]?.toDate();
    this.DateTo = to && to[0]?.toDate();
  }

  inc() {
    setTimeout(() => {
      this.count++;
      console.log("store OK");
    }, 3000);
  }

  closeTag(tag) {
    this.gridTypeIds = this.gridTypeIds.filter((id) => id != tag.id);
  }

  clearFilter() {
    this.DateFrom = null;
    this.DateTo = null;
    this.gridTypeIds = [];
    this.Eliminated = null;
    this.organizationIds = [];
    this.OverBuildingsFrom = null;
    this.OverBuildingsTo = null;
    this.LivingBuildingsFrom = null;
    this.LivingBuildingsTo = null;
    this.HospitalBuildingsFrom = null;
    this.HospitalBuildingsTo = null;
    this.ChildrenBuildingsFrom = null;
    this.ChildrenBuildingsTo = null;
    this.DisconnectedFrom = null;
    this.DisconnectedTo = null;
  }

  getDefectsByGridTypes() {
    axios
      .get(`/sp/analytics/defectsbygridtypes`, {
        params: {
          DateFrom: this.DateFrom,
          DateTo: this.DateTo,
          gridTypeIds: this.gridTypeIds,
          Eliminated: this.Eliminated,
          organizationIds: this.organizationIds,
          OverBuildingsFrom: this.OverBuildingsFrom,
          OverBuildingsTo: this.OverBuildingsTo,
          LivingBuildingsFrom: this.LivingBuildingsFrom,
          LivingBuildingsTo: this.OverBuildingsTo,
          HospitalBuildingsFrom: this.HospitalBuildingsFrom,
          HospitalBuildingsTo: this.HospitalBuildingsTo,
          ChildrenBuildingsFrom: this.ChildrenBuildingsFrom,
          ChildrenBuildingsTo: this.ChildrenBuildingsTo,
          DisconnectedFrom: this.DisconnectedFrom,
          DisconnectedTo: this.DisconnectedTo,
        },
      })
      .then((res) => {
        this.defectsByGridTypes = res.data;
      });
  }

  getEventsByOrganization() {
    axios
      .get(`/sp/analytics/eventsbyorganization`, {
        params: {
          DateFrom: this.DateFrom,
          DateTo: this.DateTo,
          gridTypeIds: this.gridTypeIds,
          Eliminated: this.Eliminated,
          organizationIds: this.organizationIds,
          OverBuildingsFrom: this.OverBuildingsFrom,
          OverBuildingsTo: this.OverBuildingsTo,
          LivingBuildingsFrom: this.LivingBuildingsFrom,
          LivingBuildingsTo: this.OverBuildingsTo,
          HospitalBuildingsFrom: this.HospitalBuildingsFrom,
          HospitalBuildingsTo: this.HospitalBuildingsTo,
          ChildrenBuildingsFrom: this.ChildrenBuildingsFrom,
          ChildrenBuildingsTo: this.ChildrenBuildingsTo,
          DisconnectedFrom: this.DisconnectedFrom,
          DisconnectedTo: this.DisconnectedTo,
        },
      })
      .then((res) => {
        this.list = res.data;
      });
  }

  getSummary() {
    axios
      .get(`/sp/analytics/summary`, {
        params: {
          DateFrom: this.DateFrom,
          DateTo: this.DateTo,
          gridTypeIds: this.gridTypeIds,
          Eliminated: this.Eliminated,
          organizationIds: this.organizationIds,
          OverBuildingsFrom: this.OverBuildingsFrom,
          OverBuildingsTo: this.OverBuildingsTo,
          LivingBuildingsFrom: this.LivingBuildingsFrom,
          LivingBuildingsTo: this.OverBuildingsTo,
          HospitalBuildingsFrom: this.HospitalBuildingsFrom,
          HospitalBuildingsTo: this.HospitalBuildingsTo,
          ChildrenBuildingsFrom: this.ChildrenBuildingsFrom,
          ChildrenBuildingsTo: this.ChildrenBuildingsTo,
          DisconnectedFrom: this.DisconnectedFrom,
          DisconnectedTo: this.DisconnectedTo,
        },
      })
      .then((res) => {
        this.summaryData = res.data;
      });
  }
  getEventsByStatus() {
    axios
      .get(`/sp/analytics/eventsbystatus`, {
        params: {
          DateFrom: this.DateFrom,
          DateTo: this.DateTo,
          gridTypeIds: this.gridTypeIds,
          Eliminated: this.Eliminated,
          organizationIds: this.organizationIds,
          OverBuildingsFrom: this.OverBuildingsFrom,
          OverBuildingsTo: this.OverBuildingsTo,
          LivingBuildingsFrom: this.LivingBuildingsFrom,
          LivingBuildingsTo: this.OverBuildingsTo,
          HospitalBuildingsFrom: this.HospitalBuildingsFrom,
          HospitalBuildingsTo: this.HospitalBuildingsTo,
          ChildrenBuildingsFrom: this.ChildrenBuildingsFrom,
          ChildrenBuildingsTo: this.ChildrenBuildingsTo,
          DisconnectedFrom: this.DisconnectedFrom,
          DisconnectedTo: this.DisconnectedTo,
        },
      })
      .then((res) => {
        this.orgs = res.data;
      });
  }
}
